import { render, staticRenderFns } from "./OrderSuccessModal.vue?vue&type=template&id=47d47e77&scoped=true&"
import script from "./OrderSuccessModal.vue?vue&type=script&lang=js&"
export * from "./OrderSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderSuccessModal.vue?vue&type=style&index=0&id=47d47e77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d47e77",
  null
  
)

export default component.exports